import { memo, FC, Dispatch, SetStateAction, useMemo } from 'react'
import { Flex, FlexProps, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react'

import { RefreshButton } from 'components'
import {
  CustomFormCommonEntityFilterKeyString,
  CustomFormCommonEntityKeyString,
} from '../../components/Viewer/components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection/components/CustomFormEntitiesQuestions/components/CustomFormCommonEntitySelectionDrawer/types'

type Props = FlexProps & {
  entityFilter: CustomFormCommonEntityFilterKeyString
  setEntityFilter: Dispatch<SetStateAction<CustomFormCommonEntityFilterKeyString>>
}

const CustomFormCommonEntityFilterTags: FC<Props> = ({ entityFilter, setEntityFilter, ...flexProps }) => {
  const entityInitialFilter: CustomFormCommonEntityFilterKeyString = {
    name: '',
    state_name: '',
  }

  function getEntityFilterFeedbacks(value: string) {
    const filterFeedbacks: CustomFormCommonEntityKeyString = {
      name: `Nome: ${value}`,
      state_name: `Estado: ${value}`,
    }
    return filterFeedbacks
  }

  const filtersWithValue = useMemo(() => {
    return Object.entries(entityFilter).filter(([key]) => {
      return entityFilter[key] !== entityInitialFilter[key]
    })
  }, [entityFilter])

  function resetFilterByKey(key: string) {
    setEntityFilter({ ...entityFilter, [key]: '' })
  }

  function resetAllFilters() {
    setEntityFilter(entityInitialFilter)
  }

  function setFilterFeedbackInTagByKey(key: string, value: string) {
    const filterTagFeedbacks: CustomFormCommonEntityFilterKeyString = getEntityFilterFeedbacks(value)
    return filterTagFeedbacks[key]
  }

  if (filtersWithValue.length === 0) return null

  return (
    <Flex align="center" flexWrap="wrap" gap={2} {...flexProps}>
      {filtersWithValue.map(([key, value]) => (
        <Tag key={key} variant="filter-tags">
          <TagLabel>{setFilterFeedbackInTagByKey(key, value)}</TagLabel>
          <TagCloseButton onClick={() => resetFilterByKey(key)} />
        </Tag>
      ))}

      <RefreshButton onClick={resetAllFilters}>Limpar filtros</RefreshButton>
    </Flex>
  )
}

export default memo(CustomFormCommonEntityFilterTags)
